import { zxcvbn } from "@zxcvbn-ts/core";
import i18n from "i18next";
import { isTruthy } from "shared/utils/utils";
import { TestContext } from "yup";
import * as yup from "yup";

// From https://github.com/dropbox/zxcvbn/blob/master/README.md
//
// result.score      # Integer from 0-4 (useful for implementing a strength bar)
//   0 # too guessable: risky password. (guesses < 10^3)
//   1 # very guessable: protection from throttled online attacks. (guesses < 10^6)
//   2 # somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8)
//   3 # safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10)
//   4 # very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
export const MIN_PASSWORD_SCORE = 2;

export const colorSchemeForPasswordScore = {
  0: "red",
  1: "orange",
  2: "yellow",
  3: "green",
  4: "green",
};

export const passwordSetupSchema = yup.object().shape({
  password: yup
    .string()
    .required(i18n.t("errors:auth.password.required"))
    .test(function (value, { options: { context } }) {
      const result = zxcvbn(value, [context?.email].filter(isTruthy));
      const { path, createError } = this as TestContext;
      if (result.score < MIN_PASSWORD_SCORE) {
        return createError({
          path,
          message: [result.feedback.warning, ...result.feedback.suggestions]
            .filter(Boolean)
            .join(" "),
        });
      }
      return true;
    }),
});
